import React from 'react';
import PropTypes from 'prop-types';
import OverviewTable from '../../../components/Table/OverviewTable';

const columnDefinition = [
  { id: 'email', label: 'Email' },
  { id: 'firstName', label: 'Vorname' },
  { id: 'lastName', label: 'Nachname' },
];

export default function UserOverviewTable({ users, onUserClick }) {
  return (
    <OverviewTable
      columnDefinition={columnDefinition}
      data={users}
      onRowClick={user => onUserClick(user.id)}
    />
  );
}

UserOverviewTable.propTypes = {
  users: PropTypes.array,
  onUserClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/users/components/UserOverviewTable.jsx